'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CharacterValidator = function () {
  function CharacterValidator() {
    _classCallCheck(this, CharacterValidator);

    this.restrict = 'A';
    this.require = 'ngModel';
    this.scope = {};

    /**
     *  basic - Decimal 32-126 + Decimal 160-255
     *  extented - Decimal 32-126 + Decimal 160-255 + Decimal 256-383 + Decimal 384-591 + Decimal 688-767
     *  supplement - Decimal 32-126 + Decimal 160-255
     * Link
     * @param  {Object} scope
     * @param  {Object} element
     * @param  {Object} attrs
     * @param  {Array} requiredCtrls
     * @return {Void}
     */
    this.link = function (scope, element, attrs, modelCtrl) {
      modelCtrl.$validators.characters = function (modelValue) {

        var regrexp = '';

        switch (attrs.characterValidator) {

          case 'basic':
            regrexp = /^[\x20-\x7E]+$/;
            break;
          case 'extented':
            regrexp = /^[\x20-\x7E\xA0-\u024F\u02B0-\u02FF]+$/;
            break;
          case 'supplement':
            regrexp = /^[\x20-\x7E\xA0-\xFF]+$/;
            break;
          case 'number':
            regrexp = /^[\x30-\x39]+$/;
            break;
        }
        if (regrexp.test(modelValue) || modelValue === undefined || modelValue === null || modelValue === '') {
          // input is valid
          return true;
        }

        // input is invalid
        return false;
      };
    };
  }

  /**
   * Factory
   * @return {Object}
   */


  _createClass(CharacterValidator, null, [{
    key: 'directiveFactory',
    value: function directiveFactory() {
      CharacterValidator.instance = new CharacterValidator();
      return CharacterValidator.instance;
    }
  }]);

  return CharacterValidator;
}();

exports.default = CharacterValidator;


/** WEBPACK FOOTER **
 ** ./src/app/directives/formValidators/characterValidator.js
 **/